import React from 'react';
import PropTypes from 'prop-types';
import { colorGrid } from 's2s-themes';
import styled from 'styled-components';
import CallList from './callList';
import UserControls from './userControls/index';
import { compose } from 'recompose';
import { injectIntl } from 'react-intl';
import { getIntlText } from '../js/utilities';

const composedHoc = compose(injectIntl);
const ComposedCallList = composedHoc(CallList);
const ComposedUserControls = composedHoc(UserControls);
const Container = styled.div``;

const SoftphoneContainer = styled.div`
  background-color: ${colorGrid.gray2};
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.2);
  display : flex;
  flex-direction: column;
  height: calc(100vh - 50px); // (647 - 50px header height)
  overflow: hidden;
  position: absolute;
  width : 100%;
`;

const ActiveCallContainer = styled.div`
  display: flex;
  flex: 1;
  overflow: hidden;
`;


const SoftPhone = (props) => {
  const handleActiveCallClick = (callInfo, e) => {
    props.cbUserAction('set-active-call', callInfo, e);
  };

  const getCallListHeader = () => {
    let returnHeader = null;

    if (props.userControlStatus === "attendedTransfer") {
      // TODO  SOFTPHONE-336 this should be internationalized....
      returnHeader = "Attended Transfer";
    }

    if (props.userControlStatus === "initiateTransfer") {
      returnHeader = getIntlText(props.intl, 'CALL-LIST-HEADER-TEXT', 'Transfer call');
    }
    return returnHeader;
  };

  return (
    <Container
      className="Container"
      id="parent"
    >
      <SoftphoneContainer className="SoftphoneContainer" >
        <ActiveCallContainer className="ActiveCallContainer">
          <ComposedCallList
            className="CallList"
            cbOnClick={handleActiveCallClick}
            listHeader={getCallListHeader()}
          />
        </ActiveCallContainer>
        <ComposedUserControls
          cbUserAction={props.cbUserAction}
          cbCallHistoryClick={props.cbCallHistoryClick}
          userControlStatus={props.userControlStatus}
          showAddCallKeypad={props.showAddCallKeypad}
          setShowAddCallKeypad={props.setShowAddCallKeypad}
        />
      </SoftphoneContainer>
    </Container>
  );
};

SoftPhone.propTypes = {
  cbCallHistoryClick: PropTypes.func,
  cbRefreshDevices: PropTypes.func,
  cbUserAction: PropTypes.func,
  userControlStatus: PropTypes.string,
  uiState: PropTypes.string,
  intl: PropTypes.object,
  showAddCallKeypad: PropTypes.bool,
  setShowAddCallKeypad: PropTypes.func

};

SoftPhone.defaultProps = {
  cbCallHistoryClick: () => { },
  cbRefreshDevices: () => { },
  cbUserAction: () => { },
  userControlStatus: "zero"
};

export default injectIntl(SoftPhone);
